<TextInputStyleProvider><BaseInput v-bind="$attrs" :label="label" :type="InputElementTypes.Tel"></BaseInput></TextInputStyleProvider>